import {
  Checkbox,
  Paragraph,
  Tooltip,
  TooltipAdvancedContent,
  TooltipButton,
} from "@smartsuite/react-ui/lib";
import type React from "react";
import * as S from "./styles";
import { SplitType } from "@smartsuite/automation-engine-api";
import { t } from "i18next";
import { GrayColors } from "@smartsuite/types";

export const ParseValues: React.FC<{
  splitType: SplitType;
  onChange: (splitType: SplitType) => void;
}> = ({ splitType, onChange }) => {
  return (
    <S.Wrapper>
      <Paragraph
        size={"xs"}
        styles={{ width: 300, display: "flex", alignItems: "center" }}
      >
        <S.CheckboxSection>
          <Checkbox
            checked={splitType === SplitType.SEMICOLON}
            onChange={(checked) => {
              onChange(checked ? SplitType.SEMICOLON : SplitType.NONE);
            }}
          />
        </S.CheckboxSection>
        <S.CheckboxText
          onClick={() => {
            onChange(
              splitType === SplitType.SEMICOLON
                ? SplitType.NONE
                : SplitType.SEMICOLON,
            );
          }}
        >
          {t("editor.parse-values")}
        </S.CheckboxText>
        <>
          <Tooltip
            display="inline-flex"
            maxWidth={210}
            padding={2}
            placements={["top"]}
            text={t("editor.parse-values-tooltip")}
            target={
              <TooltipButton
                iconSize="S"
                iconName="info-filled"
                colors={{
                  hover: GrayColors["G-7"],
                }}
              />
            }
            renderTooltipContent={
              <TooltipAdvancedContent
                minWidth={190}
                imageHeight={220}
                paddingType="uniform"
                text={t("editor.parse-values-tooltip")}
                textSize="xs"
                textWeight="semibold"
              />
            }
          />
        </>
        <S.VerticalLine />
      </Paragraph>
    </S.Wrapper>
  );
};
